import { render, staticRenderFns } from "./AnnouncementInfo.vue?vue&type=template&id=acaff588&"
import script from "./AnnouncementInfo.vue?vue&type=script&lang=js&"
export * from "./AnnouncementInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports